import { render } from "./ProsesProgram.vue?vue&type=template&id=5e80e436"
import script from "./ProsesProgram.vue?vue&type=script&lang=js"
export * from "./ProsesProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__